import { Controller } from "@hotwired/stimulus";

// Lets the sections below the hero settle into place as they scroll in, one
// slow exhale each. The hiding is armed here rather than in the markup, so a
// page whose script never runs shows everything at once instead of nothing.

export default class extends Controller {
  static targets = ["item"];

  connect() {
    if (!("IntersectionObserver" in window)) return;

    this.element.classList.add("reveal-armed");
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-revealed");
        this.observer.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -10% 0px" });
    this.itemTargets.forEach((item) => this.observer.observe(item));
  }

  disconnect() {
    this.observer?.disconnect();
    this.element.classList.remove("reveal-armed");
  }
}
